/**
 * @generated SignedSource<<bfbd2f44c6bbefb409c58791dc1b654c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorSettingsMenu_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenuCatering_package" | "RoomRatesEditorSettingsMenuRooms_package">;
  readonly " $fragmentType": "RoomRatesEditorSettingsMenu_package";
};
export type RoomRatesEditorSettingsMenu_package$key = {
  readonly " $data"?: RoomRatesEditorSettingsMenu_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenu_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorSettingsMenu_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorSettingsMenuRooms_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorSettingsMenuCatering_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "fe951ff0298386d50ee3f017eef20ba5";

export default node;
